import Env from '../base/env';
import { module } from 'modujs';
import { RevealScale } from '../fx/Common';
import gsap from 'gsap';

export default class extends module {
  init() {
    this.DOM = {};
    this.DOM.view = this.el;

    //? Fns
    gsap.delayedCall(Env.timingDelayFx, () => {
      RevealScale(this.DOM.view);
    });
  }
}
